/**
 * Проверяет, что значение — DOMException (например, `AbortSignal.abort().reason`).
 *
 * Проверка по тегу типа, а не через `instanceof`: у объекта из другого realm
 * (vm-контекст, окружение jest) прототипы чужие, и `instanceof Error` для него ложен.
 */
export function isDomException(err: unknown): err is DOMException {
    return Object.prototype.toString.call(err) === '[object DOMException]';
}
